/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-anonymous-default-export */
import {
  Checkbox,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  notification,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import { FilterValue } from "antd/lib/table/interface";
import { useContext, useEffect, useRef, useState } from "react";
import DataFilter from "../../common/components/DataFilter";
import DataTable, { DataTableRef } from "../../common/components/DataTable";
import EditableCell from "../../common/components/EditableCell";
import MainLayout from "../../common/components/MainLayout";
import InfraccionesBrowser from "../components/InfraccionesBrowser";
import useInfraccionesRadarAPI, {
  Infraccion,
} from "../hooks/useInfraccionesAPI";
import {
  FiltroInfraccionesRef,
} from "../../infracciones/components/FiltroInfracciones";
import VerificacionViewer from "../../lotes-verificacion/components/VerificacionViewer";
import styled, { createGlobalStyle } from "styled-components";
import ActaPreview, { ActaPreviewRef } from "../components/ActaPreview";
import useLotesImpresionAPI from "../../lotes-impresion/useLotesImpresionAPI";
import Paragraph from "antd/lib/typography/Paragraph";
import UsuariosContext from "../../common/contexts/UsuariosContext";
import { Query } from "@testing-library/react";
import { ManOutlined, SearchOutlined } from "@ant-design/icons";
import InfraccionDetalle from "../components/ModalDetalleInfraccion";

const GlobalStyle = createGlobalStyle`
  table
{
    min-width:1600px!important;
}
`;

const SpinnClass = styled.div`
{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.4);
  z-index: 1000;
}
`;

const FullScreenSpinner = ({ spinning = false, tip = '' }) => {
  if (!spinning) return null; // Evita renderizar el contenedor cuando spinning es falso

  return (
    <SpinnClass>
      <Spin tip={tip} size="large" />
    </SpinnClass>
  );
};

export default () => {
  const refTable = useRef<DataTableRef>(null!);
  const filtroInfraccionesRef = useRef<FiltroInfraccionesRef>(null);
  const api = useInfraccionesRadarAPI();
  const apiLoteImpresion = useLotesImpresionAPI();
  const [isModalRenombradoVisible, setIsModalRenombradoVisible] = useState<boolean>()
  const [patenteFilterForm] = Form.useForm();
  const [dniFilterForm] = Form.useForm();
  const [cuilFilterForm] = Form.useForm();
  const [nroLoteConsultaForm] = Form.useForm();
  const [nroLoteExportacionForm] = Form.useForm();
  const [idFilterForm] = Form.useForm();
  const [estadoPagoForm] = Form.useForm();
  const actaPreviewRef = useRef<ActaPreviewRef>(null!);
  const [selectedInfraccionId, setSelectedInfraccionId] = useState<number>();
  const [loteImpresionId, setLoteImpresionId] = useState<number | null>(null);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState<boolean>(false);
  const [spinVisible, setSpinVisible] = useState<boolean>(false);
  const [infraccionPdfUrl, setInfraccionPdfUrl] = useState<string>();
  const [diasVencimiento, setDiasVencimiento] = useState<number>(0);
  const valoresEstadoSelect = ["PENDIENTE", "RENOMBRADA", "CONSULTANDO", "CONSULTADA", "VERIFICADA", "EXPORTADA", "IMPRESION_GENERADA", "DESCARTADA"]
  const usersContext = useContext(UsuariosContext);
  const [EquiposMunicipio, setEquiposMunicipio] = useState<string>("");
  const [mantenerValores, setMantenerValores] = useState(false);
  const [isModalDetalleOpen, setIsModalDetalleOpen] = useState(false);
  const [infraccionDetalleData, setInfraccionDetalleData] = useState({});

  const changeColorEstado = (record: string) => {
    let colorEstado = "geekblue";
    if (record === "EXPORTADA") {
      colorEstado = "green";
    } else if (record === "DESCARTADA") {
      colorEstado = "red";
    } else if (record === "VERIFICADA") {
      colorEstado = "purple";
    } else if (record === "IMPRESION_EXCLUIDA") {
      colorEstado = "orange";
    } else if (record === "CONSULTANDO" || record === "CONSULTADA") {
      colorEstado = "gold";
    }

    return colorEstado;
  };

  const handleLoteImpresionIdChange = (e: any) => {
    setLoteImpresionId(e);
  };

  const previewActa = (id: number, estado: string, titularId: number) => {
    actaPreviewRef.current.setInfraccionId(id.toString());
    actaPreviewRef.current.setInfraccionEstado(estado);
    actaPreviewRef.current.setTitularId(titularId);
    actaPreviewRef.current.setOpen(true);
  }

  const updateActa = async (infraccionId: number) => {
    setSpinVisible(true);
    const response = await api.downloadUpdateActa(infraccionId, diasVencimiento, mantenerValores);
    if (response.data) {
      setSpinVisible(false);
      window.open(response.data, '_blank');
    }

    if (response.message) {
      setSpinVisible(false);
      notification.error({
        message: 'Error al descargar el acta actualizada'
      })
    }
  }

  const generateFilters = (filters: Record<string, FilterValue | null>) => {

    return [
      filters?.Id != null ? `Id eq ${filters!.Id[0]}` : "",
      filters?.EstadoPago !== null && filters.EstadoPago![0] === true ?
        `EstadoPago eq 'PAGADA'` :
        "",
      filters?.["ConveniosPagosInfraccion/ConvenioPagoId"] !== null ?
        `ConveniosPagosInfraccion/any(property:property/ConvenioPagoId eq ${filters?.["ConveniosPagosInfraccion/ConvenioPagoId"]![0]})` :
        "",
      filters?.Patente != null
        ? `contains(Patente,'${filters!.Patente![0]}')`
        : "",
      filters?.["Titular/DocumentoTitular"] != null
        ? `contains(Titular/DocumentoTitular,'${filters!["Titular/DocumentoTitular"]![0]
        }')`
        : "",
      filters?.["Titular/CuitTitular"] != null
        ? `contains(Titular/CuilTitular,'${filters!["Titular/CuitTitular"]![0]
        }')`
        : "",
      filters?.Estado != null ? `Estado eq '${filters!.Estado[0]}'` : "",
      filters?.["LoteConsulta/NroLote"] != null
        ? `LoteConsulta/NroLote eq ${filters!["LoteConsulta/NroLote"]![0]}`
        : "",
      filters?.["LoteExportacion/NroLote"] != null
        ? `LoteExportacion/NroLote eq ${filters!["LoteExportacion/NroLote"]![0]
        }`
        : "",
      filters?.EstadoCorreoArgentino != null && filters!.EstadoCorreoArgentino[0] == 1 ?
        `Correo/CodigoEstado eq 1` : ""
    ];

  }

  const downloadLastPrint = async (id: number) => {
    setSpinVisible(true);
    actaPreviewRef.current.setInfraccionId('');
    actaPreviewRef.current.setInfraccionEstado('');
    actaPreviewRef.current.setOpen(false);
    try {
      const response = await apiLoteImpresion.getActaPdf(id);
      setSpinVisible(false);
      if (response.error) throw Error;
      setInfraccionPdfUrl(response.data?.value);
    }
    catch (e) {
      message.error("Error al descargar el PDF");
      setSpinVisible(false);
    }
  };

  const handleInfraccionDetalle = async (idInfraccion: number) => {
    try {
      var response = await api.infraccionDetalle(idInfraccion)
      .then((response)=>{
        console.log(response)
            setInfraccionDetalleData(response)
            setIsModalDetalleOpen(true);
      });
    

    } catch (error) {

    }
  }

  useEffect(() => {
    setEquiposMunicipio(usersContext.user!.identificadoresEquipoJuzgado!.join());
  }, [EquiposMunicipio]);

  return (
    <MainLayout>
      <GlobalStyle />
      <ActaPreview ref={actaPreviewRef} />
              <Modal
        title="Detalle de Infracción"
        open={isModalDetalleOpen}
        onCancel={() => setIsModalDetalleOpen(false)}
        footer={null}
        width="90%"
        style={{ maxWidth: 1200 }}
      >
        <InfraccionDetalle data={infraccionDetalleData} />
      </Modal>
      <Modal
        cancelText="Cancelar"
        // okText="OK"
        afterClose={async () => await refTable.current.loadItems()}
        onOk={() => {
          console.log('preview')
          setIsModalRenombradoVisible(false)
        }}
        width={"85%"}
        open={isModalRenombradoVisible}
        onCancel={() => {
          setIsModalRenombradoVisible(false)
        }}
        key={`modal-${selectedInfraccionId}`}
      >


        <InfraccionesBrowser
          getItemStatusColor={(index, page, infraccion) => {
            return "";
          }}
          title="Datos del Titular"
          limit={20}
          list={(top, skip) => api.list({ $top: top, $skip: skip, $filter: [`Id eq ${selectedInfraccionId}`], $expand: ["Imagenes", "ImagenPatente", "Titular", "LoteConsulta"] })}
          findById={(id) => api.list({ $filter: [`Id eq ${id}`], $expand: ["Imagenes", "ImagenPatente", "Titular", "LoteConsulta"] })}
        >
          <VerificacionViewer />
        </InfraccionesBrowser>
      </Modal>

      <Modal
        title="¿Estás seguro?"
        open={isConfirmModalVisible}
        onOk={(item) => { updateActa(selectedInfraccionId ?? 0,); setIsConfirmModalVisible(false) }}
        onCancel={() => { console.log('Acción cancelada'); setIsConfirmModalVisible(false) }}
        okText="Confirmar"
        cancelText="Cancelar"
        okType="primary"
      >
        <Paragraph>Días de vencimiento: </Paragraph>
        <Input onChange={(e) => setDiasVencimiento(Number(e.target.value))} value={diasVencimiento} size="small" style={{ width: "30%" }} type="number" />
        <Paragraph>Esta por regenerar el acta número {selectedInfraccionId}. ¿Quieres continuar?</Paragraph>
        <Checkbox
          style={{ margin: 10 }}
          checked={mantenerValores}
          onChange={(e) => setMantenerValores(e.target.checked)}>
          Mantener valores actuales?
        </Checkbox>
      </Modal>

      <Modal
        width={"90%"}
        style={{ maxWidth: "1024px" }}
        bodyStyle={{ height: "80vh", overflow: "auto" }}
        onCancel={() => setInfraccionPdfUrl(undefined)}
        open={infraccionPdfUrl !== undefined}
        destroyOnClose>
        {infraccionPdfUrl && <iframe style={{ width: "100%", height: "100%" }} src={`${infraccionPdfUrl}?timestamp=${new Date().getTime()}`} />}
      </Modal>

      <FullScreenSpinner spinning={spinVisible} tip="Procesando..." />
      <DataTable<Infraccion, Infraccion>
        list={(query) => api.list({ ...query, ...{ $expand: ["Titular", "LoteConsulta", "LoteExportacion", "Correo", "ConveniosPagosInfraccion"] } })}
        delete={async (id) => {
          const result = await api.delete(id);
          await filtroInfraccionesRef.current?.loadTotal();
          return result;
        }}
        title={"Infracciones"}
        generateFilters={generateFilters}
        defaultPageSize={10}
        defaultSortOrder="Id desc"
        ref={refTable}
        itemActions={[
          {
            key: 'renombradoDatosTitular',
            label: 'Editar titular',
            action: (item) => {
              setSelectedInfraccionId(item.Id);
              setIsModalRenombradoVisible(true)
            }
          },
          /* {
            key: 'preview',
            label: 'Previsualizar acta',
            checkDisabled: (selectedItems, currentIndex, items) => {
              return false;
            },
            action: (item) => {
              previewActa(item.Id, item.Estado, item.Titular?.Id);
            }
          }, */
          {
            key: 'updateActa',
            label: 'Regenerar acta',
            checkDisabled: (selectedItems, currentIndex, items) => {
              return false;
            },
            action: (item) => {
              if (item.Estado != 'IMPRESION_GENERADA') {
                notification.info({ message: 'No se puede actualizar, solo con impresión generada.' })
              }
              else if (item.EstadoPago == 'PAGADA') {
                notification.info({ message: 'No se puede actualizar, ya fue pagada.' })
              }
              else {
                setSelectedInfraccionId(item.Id);
                setIsConfirmModalVisible(true);
                //updateActa(item.Id, item.Estado, item.Titular?.Id);
              }
            }
          },
          {
            key: 'downloadLastPrint',
            label: 'Descargar última impresa',
            action: (item) => {
              if (item.Estado != 'IMPRESION_GENERADA') {
                notification.info({ message: 'No se puede descargar, solo con impresión generada.' })
              }
              else {
                downloadLastPrint(item.Id);
              }

              return null;
            }
          },
          {
            key: 'detalle',
            label:  '🔍 Ver detalle',
            action: (item) => {
              handleInfraccionDetalle(item.Id);
            }
          },

        ]}
      >
        <Table.Column<Infraccion>
          width={`${65 * 0.1}%`}
          title="N° Acta"
          dataIndex={"Id"}
          align="center"
          sorter
          defaultSortOrder={"descend"}
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: 'center' }}>
              {record.Id
                ? record.Id
                : "-"}
            </div>
          )}
          filterDropdown={(props) => {
            return (
              <DataFilter
                filterDropdownProps={props}
                form={idFilterForm}
              >
                <Form.Item name={"Id"} style={{ marginBottom: 10 }}>
                  <Input placeholder="Nro Acta..."></Input>
                </Form.Item>
              </DataFilter>
            );
          }}
        />

        <Table.Column<Infraccion>
          width={`${65 * 0.1}%`}
          title="Estado Pago"
          dataIndex={"EstadoPago"}
          align="center"
          sorter
          defaultSortOrder={"descend"}
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: "center" }}>
              {
                record.EstadoPago ? record.EstadoPago : " - "
              }
            </div>
          )}
          filterDropdown={(props) => {
            return (
              <DataFilter filterDropdownProps={props} form={estadoPagoForm}>
                <Form.Item name={"EstadoPago"} style={{ marginBottom: 10 }} valuePropName="checked">
                  <Checkbox>Pagadas</Checkbox>
                </Form.Item>
              </DataFilter>
            );
          }}
        />

        <Table.Column<Infraccion>
          width={`${65 * 0.1}%`}
          title="Nro. de Convenio de pago"
          dataIndex={"ConveniosPagosInfraccion/ConvenioPagoId"}
          align="center"
          render={(val, record) => {
            return <div>
              {
                record.ConveniosPagosInfraccion.length > 0 ? record.ConveniosPagosInfraccion[0].ConvenioPagoId : " - "
              }
            </div>
          }}
          filterDropdown={(props) => {
            return (
              <DataFilter filterDropdownProps={props} form={estadoPagoForm}>
                <Form.Item name={"ConvenioPagoId"} style={{ marginBottom: 10 }}>
                  <Input placeholder="N° de convenio..."></Input>
                </Form.Item>
              </DataFilter>
            );
          }}
        />

        <Table.Column<Infraccion>
          width={`${85 * 0.05}%`}
          title="Nro. de Lote de Consulta"
          dataIndex={"LoteConsulta/NroLote"}
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: 'center' }}>
              {record.LoteConsulta?.NroLote
                ? record.LoteConsulta?.NroLote
                : "-"}
            </div>
          )}
          filterDropdown={(props) => {
            return (
              <DataFilter
                filterDropdownProps={props}
                form={nroLoteConsultaForm}
              >
                <Form.Item name={"NroLote"} style={{ marginBottom: 10 }}>
                  <Input placeholder="NroLote..."></Input>
                </Form.Item>
              </DataFilter>
            );
          }}
        />

        <Table.Column<Infraccion>
          width={`${85 * 0.05}%`}
          title="Nro. de Lote de Exportación"
          dataIndex={"LoteExportacion/NroLote"}
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: 'center' }}>
              {record.LoteExportacion?.NroLote
                ? record.LoteExportacion?.NroLote
                : "-"}
            </div>
          )}
          filterDropdown={(props) => {
            return (
              <DataFilter
                filterDropdownProps={props}
                form={nroLoteExportacionForm}
              >
                <Form.Item name={"NroLote"} style={{ marginBottom: 10 }}>
                  <Input placeholder="NroLote..."></Input>
                </Form.Item>
              </DataFilter>
            );
          }}
        />

        <Table.Column<Infraccion>
          width={`${85 * 0.1}%`}
          title="Lote de Impresion"
          dataIndex={"LoteImpresionId"}
          render={(val, record) =>
            <EditableCell<Partial<Infraccion>>
              save={api.save}
              id={record.Id}
              render={(value) => {
                let lote = value.LoteImpresionId;
                return (
                  <p>{lote}</p>
                )
              }}
              formValue={{ LoteImpresionId: val }}
              formItem={
                <Form.Item style={{ marginBottom: 0, width: "150px" }} name={"LoteImpresionId"}>
                  <InputNumber style={{ width: "auto" }} name="LoteImpresionId" value={loteImpresionId} onChange={(e) => handleLoteImpresionIdChange(e)} />
                </Form.Item>
              }
              value={record}
            />
          }
        />

        <Table.Column<Infraccion>
          width={`${85 * 0.1}%`}
          title="Patente"
          dataIndex={"Patente"}
          sorter
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: 'center' }}>
              {record.Patente
                ? record.Patente
                : "-"}
            </div>
          )}
          filterDropdown={(props) => {
            return (
              <DataFilter
                filterDropdownProps={props}
                form={patenteFilterForm}
              >
                <Form.Item name={"Patente"} style={{ marginBottom: 10 }}>
                  <Input placeholder="Patente..."></Input>
                </Form.Item>
              </DataFilter>
            );
          }}
        />

        {/* <Table.Column<Infraccion>
            width={`25%`}
            title="Lugar"
            dataIndex={"Lugar"}
            sorter
            sortDirections={["ascend", "descend", "ascend"]}
          /> */}

        <Table.Column<Infraccion>
          width={`${85 * 0.2}%`}
          title="Titular"
          dataIndex={"Titular.NombreCompletoTitular"}
          render={(val, record) => (
            <div style={{ textAlign: 'center' }}>
              {record.Titular?.NombreCompletoTitular
                ? record.Titular?.NombreCompletoTitular
                : "-"}
            </div>
          )}
        />

        <Table.Column<Infraccion>
          width={`${85 * 0.1}%`}
          title="Dni Titular"
          dataIndex={"Titular/DocumentoTitular"}
          sorter
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: 'center' }}>
              {record.Titular?.DocumentoTitular
                ? record.Titular?.DocumentoTitular
                : "-"}
            </div>
          )}
          filterDropdown={(props) => {
            return (
              <DataFilter filterDropdownProps={props} form={dniFilterForm}>
                <Form.Item
                  name={"DocumentoTitular"}
                  style={{ marginBottom: 10 }}
                >

                  <Input placeholder="DNI..."></Input>
                </Form.Item>
              </DataFilter>
            );
          }}
        />

        <Table.Column<Infraccion>
          width={`${85 * 0.1}%`}
          title="Cuit/Cuil Titular"
          dataIndex={"Titular/CuitTitular"}
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: 'center' }}>
              {record.Titular?.CuilTitular
                ? record.Titular?.CuilTitular
                : "-"}
            </div>
          )}
          filterDropdown={(props) => {
            return (
              <DataFilter filterDropdownProps={props} form={cuilFilterForm}>
                <Form.Item
                  name={"CuilTitular"}
                  style={{ marginBottom: 10 }}
                >
                  <Input placeholder="Cuit/Cuil..."></Input>
                </Form.Item>
              </DataFilter>
            );
          }}
        />

        <Table.Column<Infraccion>
          width={`${85 * 0.1}%`}
          title="Tipo Titular"
          dataIndex={"Titular.TipoTitular"}
          render={(val, record) => (
            <div style={{ textAlign: 'center' }}>
              {record.Titular?.TipoTitular
                ? record.Titular?.TipoTitular
                : "-"}
            </div>
          )}
        />

        <Table.Column<Infraccion>
          width={`${85 * 0.1}%`}
          title="Estado correo"
          dataIndex={"EstadoCorreoArgentino"}
          filters={[
            { text: "Ver entregadas", value: true }
          ]}
          render={(val, record) => record.Correo ?
            <Tag color={record.Correo.CodigoEstado == 1 ? 'green' : 'red'} >{`${record.Correo.Estado}`}</Tag> :
            <Tag color="gold">Sin datos</Tag>
          }
        />

        <Table.Column<Infraccion>
          width={`${85 * 0.2}%`}
          title="Estado"
          dataIndex={"Estado"}
          sorter
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) =>
            <EditableCell<Partial<Infraccion>>
              save={api.save}
              id={record.Id}
              render={(value) => {
                let colorEstado = changeColorEstado(record.Estado);
                let estado: string = value.Estado!;
                // if (record.ImpresionExcluida) {
                //   colorEstado = 'orange';
                //   estado = "IMPRESION_EXCLUIDA";
                // }
                return [
                  <>
                    <div style={{ textAlign: "center" }}>
                      <Tag key={value.Id} color={colorEstado}>
                        {estado}
                      </Tag>
                    </div>
                  </>,
                ];
              }}
              formValue={{ Estado: val }}
              formItem={

                <Form.Item style={{ marginBottom: 0, width: "150px" }} name={"Estado"}>
                  <Select>
                    {valoresEstadoSelect.map((val, index) => (
                      <Select.Option key={index} value={val}>
                        {val}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              }
              value={record}
            />
          }
          filters={[
            { text: "PENDIENTE", value: "PENDIENTE" },
            { text: "RENOMBRADA", value: "RENOMBRADA" },
            { text: "CONSULTANDO", value: "CONSULTANDO" },
            { text: "CONSULTADA", value: "CONSULTADA" },
            { text: "EXPORTADA", value: "EXPORTADA" },
            // { text: "ACTA_GENERADA", value: "ACTA_GENERADA" },
            { text: "IMPRESION_GENERADA", value: "IMPRESION_GENERADA" },
            { text: "IMPRESION_EXCLUIDA", value: "IMPRESION_EXCLUIDA" },
            { text: "DESCARTADA", value: "DESCARTADA" },
            { text: "VERIFICADA", value: "VERIFICADA" },
          ]}
        />

        {/* <Table.Column<Infraccion>
            width={`15%`}
            title="Fecha impresión"
            dataIndex={"FechaImpresionGenerada"}
            sorter
            render={(val, record) => (
              <div style={{ textAlign: 'center' }}>
                {record.FechaImpresionGenerada
                  ? moment(record.FechaImpresionGenerada).format("DD/MM/YYYY HH:mm:ss")
                  : "-"}
              </div>
            )}
            sortDirections={["ascend", "descend", "ascend"]}
        /> */}

      </DataTable>
    </MainLayout>
  );
};
